import React from "react";

const FinalModal = ({ visible, message, onClose, onConfirm }) => {
  if (!visible) return null;

  const isSuccess = message === "Servicios listos para cargar";

  return (
    <div className="modal modal-blur custom-modal fade show" tabIndex="-1" role="dialog" aria-modal="true" style={{ display: "block" }}>
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Resultado de la validación</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <h3>{message}</h3>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cerrar
            </button>
            {isSuccess && (
              <button type="button" className="btn btn-primary" onClick={onConfirm}>
                Cargar Servicios
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinalModal;
